import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {Article} from '../../../../article/models/article.models';

@Component({
    selector: 'order-request-article-box',
    templateUrl: './order-request-article-box.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderRequestArticleBoxComponent {
  @Input() article: Article;
  @Input() workflowId?: string;
  @Input() whitebox = true;
  @Input() targetWindow = '_self';

  constructor() {
  }

}
